<script>
    export let images;
    import { setImages } from '../store';
    import List from './List.svelte';
    import Viewer from './Viewer.svelte';
    import Navigation from './Navigation.svelte';

    setImages(images || []);
</script>

<div class="viewer">
    <Navigation>
        <List />
    </Navigation>
    <Viewer />
</div>

<style>
    .viewer {
        display: grid;
        width: 100%;
        height: 100%;
        grid-gap: 10px;
        grid-template-columns: 1fr auto;
    }
</style>
